import React from 'react';
import {
  ActionList,
  ActionListItem,
  ActionListItemIcon,
  ActionListSection,
  CheckIcon,
  Dropdown,
  DropdownOverlay,
  FilterChipSelectInput,
} from '@razorpay/blade/components';

import { AddFilterMenuProps } from './types';
import { getFieldSection } from './utils';

export const AddFilterMenu = ({
  isOpen,
  isDisabled,
  sectionNames,
  definitions,
  selectedFieldKeys,
  onOpenChange,
  onAddFilter,
  onRemoveFilter,
}: AddFilterMenuProps) => {
  return (
    <Dropdown isOpen={isOpen} onOpenChange={onOpenChange}>
      <FilterChipSelectInput
        accessibilityLabel="Add Filter"
        label="Add Filter"
        value=""
        onChange={() => {}}
        isDisabled={isDisabled}
      />
      <DropdownOverlay minWidth="260px">
        <ActionList>
          {sectionNames.map((sectionName) => {
            const fieldsInSection = definitions.filter(
              (definition) => getFieldSection(definition) === sectionName,
            );

            if (!fieldsInSection.length) return null;

            return (
              <ActionListSection key={sectionName} title={sectionName.toUpperCase()}>
                {fieldsInSection.map((definition) => {
                  const isAdded = selectedFieldKeys.includes(definition.fieldKey);
                  return (
                    // Blade ignores isSelected for FilterChip-triggered dropdowns; the
                    // trailing CheckIcon is the visible checkmark. isSelected kept for
                    // aria-selected semantics.
                    <ActionListItem
                      key={definition.fieldKey}
                      title={definition.label}
                      value={definition.fieldKey}
                      isSelected={isAdded}
                      trailing={isAdded ? <ActionListItemIcon icon={CheckIcon} /> : undefined}
                      onClick={() =>
                        isAdded
                          ? onRemoveFilter(definition.fieldKey)
                          : onAddFilter(definition.fieldKey)
                      }
                    />
                  );
                })}
              </ActionListSection>
            );
          })}
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
